// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductCost_wrapper__2j4WQ"};